<template>
  <a :href="card.link" class="home-link-card" target="_blank">
    <div class="home-link-card-logo" :style="{'background':card.logoColor}">
      <img :src="card.img" alt="">
    </div>
    <div class="home-link-card-title">
      {{ this.$t(card.name) }}
    </div>
  </a>
</template>

<script>
import contents from "./content/contents";

export default {
  name: 'homeLinkCard',
  props: {
    card: {
      type: Object,
      default: {}
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/index.less';
.home-link-card{
  width: 276px;
  height: 80px;
  margin-bottom: 30px;
  margin-right: calc((1140px - 276px * 4) / 3);
  background: #F8F8F8;
  border-radius: 6px;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  border:1px solid transparent;
  text-decoration:none;
  transition: all 0.1s linear 0s;
  &:hover{
    border:1px solid #FF3D48;
    background: #ffffff;
  }
  &-logo{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FF3D48;
    &>img{
      max-width: 60%;
      max-height: 60%;
    }
  }
  &-title{
    font-size: 14px;
    color: #333333;
    line-height: 50px;
    width: calc(276px - 30px - 50px - 20px);
    text-decoration:none;
    .overflow()
  }
}
.home-link-card:nth-child(4n){
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/homeLinkCard.vue